<script lang="ts">
  import { setContext } from "svelte"
  import { getDefaultGalleryContext } from "./utils/context"

  export let id: string

  setContext(id, getDefaultGalleryContext())
</script>

<slot />
